import css from 'styled-jsx/css';
import { sansSerif } from 'styles/css-constants';

const IMAGE_BUTTON_GRAY = '#2b2b2b';

export default css`
  .AmpPrismEntryButton--button {
    display: flex;
    border: 1px solid currentColor;
    align-items: center;
    padding-right: 0.25rem;
    color: ${IMAGE_BUTTON_GRAY};
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg3);
    letter-spacing: 0.02em;
    text-decoration: none;
    text-transform: uppercase;
  }

  .AmpPrismEntryButton--button amp-img {
    margin-right: 0.25rem;
  }
`;
